/**
 * Collection page (sections/usp-collection.liquid): filter sidebar with counts, sorting and product compare.
 * Facet values come from each card's data attributes (snippets/usp-card.liquid); the facet list and price breaks
 * from collection metafield custom.facet_config. Counts follow the usual rule: a value's count is the number of
 * products that match all other active filters and have that value.
 */
(function () {
  var root = document.querySelector('[data-usp-collection]');
  if (!root) return;
  var grid = root.querySelector('[data-usp-grid]');
  var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-usp-card]'));
  var cfg = {};
  try { cfg = JSON.parse(root.querySelector('[data-usp-facet-config]').textContent) || {}; } catch (e) {}
  var facetNames = (cfg && cfg.facets) || ['Brand', 'Price'];
  var breaks = (cfg && cfg.price) || [5000, 15000, 40000];
  var money = function (n) { return '$' + Number(n).toLocaleString('en-US', { maximumFractionDigits: 0 }); };

  function priceBucket(p) {
    if (!(p > 0)) return 'Price on request';
    if (p < breaks[0]) return 'Under ' + money(breaks[0]);
    for (var i = 1; i < breaks.length; i++) if (p < breaks[i]) return money(breaks[i - 1]) + '–' + money(breaks[i]);
    return 'Over ' + money(breaks[breaks.length - 1]);
  }
  var bucketOrder = ['Under ' + money(breaks[0])];
  for (var b = 1; b < breaks.length; b++) bucketOrder.push(money(breaks[b - 1]) + '–' + money(breaks[b]));
  bucketOrder.push('Over ' + money(breaks[breaks.length - 1]), 'Price on request');

  // values per card
  var items = cards.map(function (el, i) {
    var f = {};
    try { f = JSON.parse(el.getAttribute('data-facets') || 'null') || {}; } catch (e) {}
    var vals = {};
    facetNames.forEach(function (name) {
      var v;
      if (name === 'Brand') v = el.getAttribute('data-brand');
      else if (name === 'Price') v = priceBucket(parseFloat(el.getAttribute('data-price')));
      else v = f[name];
      vals[name] = v == null || v === '' ? [] : [].concat(v);
    });
    return { el: el, i: i, vals: vals, price: parseFloat(el.getAttribute('data-price')) || 0, title: el.getAttribute('data-title') };
  });

  // facet groups (only facets with at least 2 values, or 1 value not shared by every product)
  var groups = root.querySelector('[data-usp-filter-groups]');
  var state = {};
  facetNames.forEach(function (name) {
    var seen = {};
    items.forEach(function (it) { it.vals[name].forEach(function (v) { seen[v] = true; }); });
    var values = Object.keys(seen);
    if (name === 'Price') values = bucketOrder.filter(function (v) { return seen[v]; });
    else if (cfg.order && cfg.order[name]) values.sort(function (a, b) { var o = cfg.order[name], x = o.indexOf(a), y = o.indexOf(b); return (x < 0 ? 99 : x) - (y < 0 ? 99 : y); });
    else values.sort(function (a, b) { return a.localeCompare(b, 'en', { numeric: true }); });
    if (values.length < 2) return;
    state[name] = {};
    var id = 'usp-f-' + name.toLowerCase().replace(/[^a-z0-9]+/g, '-');
    var html = '<fieldset class="usp-filters__group"><legend>' + name + '</legend><ul role="list">';
    values.forEach(function (v, k) {
      html += '<li><label for="' + id + '-' + k + '"><input type="checkbox" id="' + id + '-' + k + '" data-facet="' + name.replace(/"/g, '&quot;') +
        '" value="' + v.replace(/"/g, '&quot;') + '"><span class="usp-filters__label">' + v + '</span><span class="usp-filters__n" data-n></span></label></li>';
    });
    html += '</ul></fieldset>';
    groups.insertAdjacentHTML('beforeend', html);
  });

  function matches(it, except) {
    for (var name in state) {
      if (name === except) continue;
      var sel = Object.keys(state[name]);
      if (!sel.length) continue;
      if (!it.vals[name].some(function (v) { return state[name][v]; })) return false;
    }
    return true;
  }

  var countEl = root.querySelector('[data-usp-count]');
  var emptyEl = root.querySelector('[data-usp-empty]');
  var activeEl = root.querySelector('[data-usp-active-count]');
  var clearBtns = root.querySelectorAll('[data-usp-clear]');

  function apply() {
    var shown = 0, active = 0;
    items.forEach(function (it) {
      var ok = matches(it);
      it.el.hidden = !ok;
      if (ok) shown++;
    });
    groups.querySelectorAll('input[data-facet]').forEach(function (inp) {
      var name = inp.getAttribute('data-facet'), v = inp.value;
      var n = items.filter(function (it) { return matches(it, name) && it.vals[name].indexOf(v) >= 0; }).length;
      inp.closest('label').querySelector('[data-n]').textContent = '(' + n + ')';
      inp.closest('li').classList.toggle('is-zero', n === 0 && !inp.checked);
      if (inp.checked) active++;
    });
    countEl.textContent = shown + (shown === 1 ? ' product' : ' products');
    emptyEl.hidden = shown > 0;
    activeEl.hidden = !active;
    activeEl.textContent = active ? '(' + active + ')' : '';
    clearBtns.forEach(function (btn) { if (!btn.closest('[data-usp-empty]')) btn.hidden = !active; });
  }
  groups.addEventListener('change', function (e) {
    var inp = e.target.closest('input[data-facet]');
    if (!inp) return;
    var name = inp.getAttribute('data-facet');
    if (inp.checked) state[name][inp.value] = true; else delete state[name][inp.value];
    apply();
  });
  clearBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      for (var n in state) state[n] = {};
      groups.querySelectorAll('input[data-facet]').forEach(function (i) { i.checked = false; });
      apply();
    });
  });

  // sorting
  var sortSel = root.querySelector('[data-usp-sort]');
  sortSel.addEventListener('change', function () {
    var by = sortSel.value;
    var list = items.slice();
    if (by === 'price-asc') list.sort(function (a, b) { return (a.price || Infinity) - (b.price || Infinity); });
    else if (by === 'price-desc') list.sort(function (a, b) { return b.price - a.price; });
    else if (by === 'title') list.sort(function (a, b) { return a.title.localeCompare(b.title); });
    else list.sort(function (a, b) { return a.i - b.i; });
    list.forEach(function (it) { grid.appendChild(it.el); });
  });

  // filter panel: open on desktop, collapsed on mobile
  var panel = root.querySelector('[data-usp-filter-panel]');
  var mq = window.matchMedia('(min-width: 990px)');
  var setPanel = function () { panel.open = mq.matches; };
  setPanel();
  if (mq.addEventListener) mq.addEventListener('change', setPanel);

  // compare (up to 4)
  var bar = root.querySelector('[data-usp-compare-bar]');
  var dlg = root.querySelector('[data-usp-compare-dialog]');
  var chosen = [];
  function syncCompare() {
    bar.hidden = chosen.length === 0;
    bar.querySelector('[data-usp-compare-count]').textContent = chosen.length;
    bar.querySelector('[data-usp-compare-open]').disabled = chosen.length < 2;
    grid.querySelectorAll('input[data-usp-compare]').forEach(function (c) {
      c.disabled = !c.checked && chosen.length >= 4;
    });
  }
  grid.addEventListener('change', function (e) {
    var c = e.target.closest('input[data-usp-compare]');
    if (!c) return;
    if (c.checked && chosen.indexOf(c.value) < 0) chosen.push(c.value);
    if (!c.checked) chosen = chosen.filter(function (h) { return h !== c.value; });
    syncCompare();
  });
  bar.querySelector('[data-usp-compare-clear]').addEventListener('click', function () {
    chosen = [];
    grid.querySelectorAll('input[data-usp-compare]').forEach(function (c) { c.checked = false; });
    syncCompare();
  });
  var esc = function (t) { return String(t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); };
  bar.querySelector('[data-usp-compare-open]').addEventListener('click', function () {
    var sel = chosen.map(function (h) { return items.filter(function (it) { return it.el.getAttribute('data-handle') === h; })[0]; }).filter(Boolean);
    var rowNames = facetNames.filter(function (n) { return n !== 'Price'; });
    var html = '<table class="usp-compare-table"><thead><tr><th scope="row">Product</th>' + sel.map(function (it) {
      var img = it.el.getAttribute('data-image');
      return '<th scope="col"><a href="' + esc(it.el.getAttribute('data-url')) + '">' + (img ? '<img src="' + esc(img) + '" alt="" width="120" height="120" loading="lazy">' : '') + '<span>' + esc(it.title) + '</span></a></th>';
    }).join('') + '</tr></thead><tbody>';
    html += '<tr><th scope="row">Price</th>' + sel.map(function (it) { return '<td>' + (it.price > 0 ? '$' + it.price.toLocaleString('en-US', { minimumFractionDigits: 2 }) : 'Price on request') + '</td>'; }).join('') + '</tr>';
    rowNames.forEach(function (n) {
      html += '<tr><th scope="row">' + esc(n) + '</th>' + sel.map(function (it) { return '<td>' + esc(it.vals[n].join(', ') || '–') + '</td>'; }).join('') + '</tr>';
    });
    html += '<tr><th scope="row">Key specs</th>' + sel.map(function (it) {
      var s = []; try { s = JSON.parse(it.el.getAttribute('data-specs') || '[]') || []; } catch (e) {}
      return '<td>' + s.map(esc).join('<br>') + '</td>';
    }).join('') + '</tr></tbody></table>';
    dlg.querySelector('[data-usp-compare-table]').innerHTML = html;
    if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
  });
  dlg.querySelector('[data-usp-compare-close]').addEventListener('click', function () { dlg.close ? dlg.close() : dlg.removeAttribute('open'); });
  dlg.addEventListener('click', function (e) { if (e.target === dlg && dlg.close) dlg.close(); });

  apply();
  syncCompare();
})();
